module.exports = "../dist/img/product-card-27.8d53.jpg";